export enum PrepStationScope {
  ONLY_THIS = "ONLY_THIS",
  ALL = "ALL",
}
